import React from 'react';
import ReactDOM from 'react-dom';
import Slider from 'rc-slider';
class RangeSliderComponent extends React.Component {
  constructor(props) {
    super(props);
   
    this._onChange = this._onChange.bind(this);
  }
  _onChange(a) {
    this.props.onChange(a[0], a[1]);
  }
  RenderOverview(minimum, maximum){
    var minToShow = minimum;
    var maxToShow = maximum; 

    if(this.props.selectedMinimum){
      for (let i = 0; i < this.props.options.length; i++) {
        const option = this.props.options[i];
        if(option.Value == this.props.selectedMinimum){
          minToShow = option;
        }
      }
    }

    if(this.props.selectedMaximum){
      for (let i = 0; i < this.props.options.length; i++) {
        const option = this.props.options[i];
        if(option.Value == this.props.selectedMaximum){
          maxToShow = option;
        }
      }
    }
    if(minToShow && maxToShow){
      if(minToShow == maxToShow){
        return <p className='text-center'>{minToShow.Name}</p>
      }else{
        return <p className='text-center'>{minToShow.Name} <i className="fa fa-long-arrow-right" aria-hidden="true"></i> {maxToShow.Name}</p>
      }
      
    }
  }
  render() {


    const marks ={};
    let minimum = null;
    let maximum = null;

    for (let i = 0; i < this.props.options.length; i++) {
      const option = this.props.options[i];
      marks[option.Value] = {style:{display:"none"}, label: option.Name};
      if(minimum==null || minimum.Value > option.Value){
        minimum = option;
      } 
      if(maximum==null || maximum.Value < option.Value){
        maximum = option;
      } 
    }
     return (
      <>
            { this.props.options.length > 0 &&
            <Slider range min={minimum.Value} max={maximum.Value} marks={marks} step={null} onChange={this._onChange} allowCross={true} defaultValue={[minimum.Value, maximum.Value]} />
        }
        {this.RenderOverview(minimum, maximum)}
      </>

    );
  }
}


export default RangeSliderComponent;

